import React, { useEffect, useState } from "react";
import { Menu, MenuItem, Button, Box, TextField, Select, OutlinedInput, CardMedia } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

interface HorizontalMenuProps {
  onModelSelect: (model: string) => void;
  model?: string;
  experienceMode: string;
}

const HorizontalMenu: React.FC<HorizontalMenuProps> = ({ onModelSelect, model, experienceMode }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedModel, setSelectedModel] = useState<string>(model ?? "ball");
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (model) {
      setSelectedModel(model);
    } else {
      setSelectedModel("ball");
    }
  }, [model]);

  const handleSelectType = (model: string) => {
    setSelectedModel(model);
    onModelSelect(model);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const textMenuItem = (text: string) => {
    switch(text) {
      case "ball":
        return "Default";
      case "trisign":
        return "Tri-Sign";
      case "planet":
        return "Planet";
      case "ballnoball":
        return "Banner";
      case "billboardwide":
        return "Billboard Wide";
      case "billboardtall":
        return "Billboard Tall";
    }
  };

  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <Button
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        aria-controls={open ? "horizontal-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disabled={experienceMode === "MOD_ONLY" || experienceMode === "READ_ONLY"}
        fullWidth
        sx={{ 
          color: "black", 
          fontWeight: 400,
          fontSize: 16, 
          border:  "1px solid", 
          borderColor: "rgba(0, 0, 0, 0.23)",
          height: "55px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ ml: 1 }}>
        {selectedModel && (textMenuItem(selectedModel))}
        </Box>
      </Button>
      <Menu
        id="horizontal-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          sx: {
            display: "flex", // Makes the menu items horizontal
            flexDirection: "row",
            padding: 0,
            justifyContent: "center",
          },
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "row",
            borderRadius: 2,
          },
        }}
      >
        <MenuItem onClick={() => handleSelectType("ball")}>
          <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/default.png"}
              alt={"default"}
            />
            Default
          </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("trisign")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/trisign.png"}
              alt={"trisign"}
            />
          Tri-Sign
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("ballnoball")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/banner.png"}
              alt={"banner"}
            />
          Banner
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("planet")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/planet.png"}
              alt={"planet"}
            />
          Planet
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("billboardwide")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px", objectFit: "contain" }}
              component="img" 
              src={"/images/beaconpreview/billboardwide.png"}
              alt={"billboard"}
            />
          Billboard Wide
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("billboardtall")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px", objectFit: "contain" }}
              component="img" 
              src={"/images/beaconpreview/billboardtall.png"}
              alt={"billboard"}
            />
          Billboard Tall
        </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default HorizontalMenu;
